import { SingleChoiceQuestionConfig } from '@hyper-inferno/single-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class SingleChoiceHandler
  implements QuestionHandler<SingleChoiceQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    const key = el.name;
    return [(response[key] as number) ?? 0]; // returns number
  }
}
